import { render } from "./HeaderUser.vue?vue&type=template&id=1a4f851f&scoped=true"
import script from "./HeaderUser.vue?vue&type=script&lang=js"
export * from "./HeaderUser.vue?vue&type=script&lang=js"

import "./HeaderUser.vue?vue&type=style&index=0&id=1a4f851f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4f851f"]])

export default __exports__